goog.provide('el8.appchart.cqmRefresh');

goog.require('el8.util.localStorage')
goog.require('el8.ptdata.patients');
goog.require('el8.ptdata.ptImmunizations');
goog.require('el8.ptdata.ptImmunizationDeclines');
goog.require('el8.ptdata.ptProblems');
goog.require('el8.ptdata.reports');
goog.require('el8.ptdata.visitNotes');
goog.require('el8.ptdata.medOrders');
goog.require('el8.ptdata.xmlSummaries');
goog.require('el8.service.urls');

el8.appchart.cqmRefresh = (function() {
    var that = {
        // All fields here are considered read-only to code outside this file
        startCallbacks: [],
        updateCallbacks: [],
        endCallbacks: [],
        errorCallbacks: [],
        refreshInProgress: false,
        cqmStatus: null, // TODO: move this data into Redux store
        _measureDetails: {}
    };

    that.init = function() {
        el8.ptdata.patients.bind('all', _handleChangeEvent);
        el8.ptdata.ptImmunizations.bind('all', _handleChangeEvent);
        el8.ptdata.ptImmunizationDeclines.bind('all', _handleChangeEvent);
        el8.ptdata.ptMaintItems.bind('all', _handleChangeEvent);
        el8.ptdata.ptProblems.bind('all', _handleChangeEvent);
        el8.ptdata.reports.bind('all', _handleChangeEvent);
        el8.ptdata.smokingStatuses.bind('all', _handleChangeEvent);
        el8.ptdata.visitNotes.bind('all', _handleChangeEvent);
        el8.ptdata.medOrders.bind('all', _handleChangeEvent);
        el8.ptdata.xmlSummaries.bind('all', _handleChangeEvent);
        that.forceRefresh(true);
    };

    that.register = function(spec) {
        if (spec.startCb) { that.startCallbacks.push(spec.startCb); }
        if (spec.updateCb) { that.updateCallbacks.push(spec.updateCb); }
        if (spec.endCb) { that.endCallbacks.push(spec.endCb); }
        if (spec.errorCb) { that.errorCallbacks.push(spec.errorCb); }
    };

    that.forceRefresh = function(immediate) {
        if (!that.refreshInProgress) {
            callStartCallbacks();
            that.refreshInProgress = true;
            if (immediate) {
                fetchResults(0);
            }
            else {
                delayedRefresh(0);
            }
        }
    };

    that.fetchMeasureGuidance = function(measureId) {
        var url = el8.service.urls.get('qualityMeasureGuidance', [measureId]);
        var deferred = $.Deferred();
        if (!that._measureDetails[measureId]) {
            $.el8_ajax({
                url: url,
                dataType: 'json',
                success: function(data) {
                    that._measureDetails[measureId] = data;
                    deferred.resolve(data);
                },
                error: function() {
                    deferred.reject();
                }
            });
        }
        else {
            deferred.resolve(that._measureDetails[measureId]);
        }
        return deferred.promise();
    };

    that.getReportingYear = function() {
        return parseInt(
            el8.util.localStorage.getItem('cqm_reporting_year') || new Date().getFullYear()
        );
    };

    that.setReportingYear = function(year) {
        el8.util.localStorage.setItem('cqm_reporting_year', year);
    };

    that.isReportingCurrentYear = function() {
      return new Date().getFullYear() == that.getReportingYear();
    }

    that.getReportingDate = function() {
        if(that.isReportingCurrentYear()) {
            return Date.now();
        }

        return new Date(that.getReportingYear(), 0, 2);
    }


    function callStartCallbacks() {
        _.each(that.startCallbacks, function(cb) { cb(); });
    }

    function callUpdateCallbacks(url, changed) {
        _.each(that.updateCallbacks, function(cb) { cb(url, changed); });
    }

    function callEndCallbacks(url, changed) {
        _.each(that.endCallbacks, function(cb) { cb(url, changed); });
    }

    function callErrorCallbacks() {
        _.each(that.errorCallbacks, function(cb) { cb(); });
    }

    function fetchResults(backoffCount) {
        var patientId = el8Globals.PATIENT_ID;

        if (patientId === null) { // Ignore when we're called from outside the patient chart
            that.refreshInProgress = false;
            callEndCallbacks();
            return;
        }

        var url = el8.service.urls.get('cqmCalendarYearStatus', [that.getReportingYear()]);
        return $.el8_ajax({
            url: url,
            dataType: 'json',
            success: function(response) {
                var statusChanged = !_.isEqual(response.status, that.cqmStatus);
                that.cqmStatus = response.status;

                callUpdateCallbacks(url, statusChanged);

                if (response['update_pending']) {
                    // Update isn't done yet, or more updates to come; keep refreshing
                    delayedRefresh(backoffCount + 1);
                }
                else {
                    that.refreshInProgress = false;
                    callEndCallbacks(url, statusChanged);
                }
            },
            error_override: function() {
                callErrorCallbacks();

                delayedRefresh(backoffCount + 1, null, function() {
                  callEndCallbacks(url, false);
                  callStartCallbacks();
                });
            }
        });
    }

    function delayedRefresh(backoffCount, initialTimeout, preCb) {
        backoffCount = backoffCount || 0;
        var timeout = initialTimeout || 5000;
        if (backoffCount > 0) {
            // Cap the timeout so that if there is a constant stream of changes and pending updates,
            // we will still update regularly instead of waiting longer and longer for the updates
            // to stop
            timeout = Math.min(32000, 500 * Math.pow(2, backoffCount));
        }

        var fn = function() {
          if(preCb) preCb();
          fetchResults(backoffCount);

        };

        window.setTimeout(fn, timeout);
    }

    function _handleChangeEvent(eventType, item) {
        if (!that.refreshInProgress) {
            callStartCallbacks();
            that.refreshInProgress = true;
            if (eventType === EVENTS.CREATED && item.getModelClass() === 'VisitNote') {
                // Server recalculates faster when creating a new visit note
                delayedRefresh(0, 1000);
            }
            else {
                delayedRefresh(0);
            }
        }
    }

    return that;
})();
